import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask4600To4699Service {

  constructor() { }
}
